import React from 'react';
import queryString from 'query-string';

import PunchOutLoginForm from '../components/punchOut/PunchOutLoginForm';

const PunchOutPage = props => (
  <main className="main">
    <PunchOutLoginForm {...queryString.parse(props.location.search)} />
  </main>
);

export default PunchOutPage;
